import { DatePartOrder } from 'types';
import { formatTimestampByPartOrder } from '@utils/common-new/dates';

/**
 * Month-name date shapes per tenant date-part order, mirroring the global `dateWithStringMonth`
 * formats but with an unpadded day — the attribution line reads "Jul 9, 2026", not "Jul 09, 2026".
 */
const DATE_FORMAT_BY_ORDER: Record<string, string> = {
  DMY: 'D MMM, YYYY',
  MDY: 'MMM D, YYYY',
  YMD: 'YYYY, MMM D',
};

/** Uppercase meridiem, unlike the global `hoursMinutesMeridiem` key's lowercase `a`. */
const TIME_FORMAT = 'h:mm A';

/**
 * Renders an audit timestamp for the drawer's attribution sentence — "Jul 9, 2026 at 10:42 AM".
 *
 * The date half follows the company's date-part order so a DMY tenant reads "9 Jul, 2026"; the time
 * half is order-independent. dayjs renders in the viewer's own timezone by default, so this line
 * agrees with every other timestamp on the page without needing an explicit zone.
 *
 * Returns an empty string for an unparseable value rather than "Invalid Date", which lets the
 * caller treat it as no attribution at all.
 */
export const formatOverriddenAt = (
  isoTimestamp: string,
  datePartOrder?: DatePartOrder | string | null,
): string => formatTimestampByPartOrder(isoTimestamp, datePartOrder, DATE_FORMAT_BY_ORDER, TIME_FORMAT, ' at ');
